import type { Config } from '@/config/types.ts';

// 生产环境配置
const config: Partial<Config> = {};

export default config;
